export default __webpack_public_path__ + "resources/icons/d111-f51e.png";